import { MasterData } from './master-data';

export abstract class MasterDataRepository {
  static readonly DEFAULT_MAX_DAYS_RANGE = 210;

  abstract load(): Promise<MasterData>;
}
